import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ResourcesAPI from "../serviceAPI/ResourcesAPI";

const initialState = {
  resources: [],
  visitResourcesData:[],
  isLoading: false,
  errorCode: null,
  prevThumbnailDetails: null,
  prevThumbnailId: null,
  prevResourcesFileDetails: null,
  prevResourcesFileId: null,
};

export const getAllResources = createAsyncThunk(
  "getAllResources",
  async (officeId, { rejectWithValue }) => {
    try {
      const res = await ResourcesAPI.GetAllResources(officeId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const postResource = createAsyncThunk(
  "postResource",
  async ({ id, newData }, { rejectWithValue }) => {
    try {
      const res = await ResourcesAPI.PostResource(newData, id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const deleteResource = createAsyncThunk(
  "deleteResource",
  async (id, { rejectWithValue }) => {
    try {
      const res = await ResourcesAPI.DeleteResource(id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const updateResource = createAsyncThunk(
  "updateResource",
  async ({ id, newData }, { rejectWithValue }) => {
    try {
      const res = await ResourcesAPI.UpdateResource(id, newData);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const getAllResourcesOfVisit = createAsyncThunk(
  'getAllResourcesOfVisit',
  async (visitId, { rejectWithValue }) => {
    try {
      const res = await ResourcesAPI.GetAllResourcesOfVisit(visitId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

const ResourcesSlice = createSlice({
  name: "resources",
  initialState,
  reducers: {
    setPrevThumbnailDetails: (state, action) => {
      state.prevThumbnailDetails = action.payload;
    },
    setPreThumbnailId: (state, action) => {
      state.prevThumbnailId = action.payload;
    },
    setPrevResourcesFileDetails: (state, action) => {
      state.prevResourcesFileDetails = action.payload;
    },
    setPrevResourcesFileId: (state, action) => {
      state.prevResourcesFileId = action.payload;
    },
    resetErrorAlert: (state, action) => {
      state.errorCode = null;
    },
    addResource: (state, action) => {
      state.localResources = state.localResources.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllResources.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllResources.fulfilled, (state, action) => {
        state.isLoading = false;
        state.resources = [...action.payload];
      })
      .addCase(getAllResources.rejected, (state, action) => {
        state.isLoading = false;
        state.errorCode = action.payload;
      })
      .addCase(getAllResourcesOfVisit.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllResourcesOfVisit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.visitResourcesData = [...action.payload];
      })
      .addCase(getAllResourcesOfVisit.rejected, (state, action) => {
        state.isLoading = false;
        state.errorCode = action.payload;
      })
      .addCase(postResource.fulfilled, (state, action) => {
        action.payload.forEach((element) => {
          state.resources.push(element);
        });
      })
      .addCase(postResource.rejected, (state, action) => {
        state.errorCode = action.payload;
      })
      .addCase(deleteResource.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteResource.fulfilled, (state, action) => {
        state.isLoading = false;
        const id = action.payload._id;
        const index = state.resources.map((item) => item._id).indexOf(id);
        state.resources.splice(index, 1);
      })
      .addCase(deleteResource.rejected, (state, action) => {
        state.isLoading = false;
        state.errorCode = action.payload;
      })
      .addCase(updateResource.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateResource.fulfilled, (state, action) => {
        state.isLoading = false;
        const id = action.payload._id;
        state.resources = state.resources.map((item) =>
          item._id === id ? action.payload : item
        );
      })
      .addCase(updateResource.rejected, (state, action) => {
        state.isLoading = false;
        state.errorCode = action.payload;
      });
  },
});

export const {
  setPrevResourcesFileDetails,
  setPrevResourcesFileId,
  setPrevThumbnailDetails,
  setPreThumbnailId,
  addResource,
  resetErrorAlert,
} = ResourcesSlice.actions;

export default ResourcesSlice.reducer;
